import React from 'react';
import {
    Box,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import { Container } from '@mui/material';

interface LoadingSkeletonProps {
    rows?: number;
    columns?: number;
}

const LoadingSkeleton = ({ rows = 7, columns = 7 }: LoadingSkeletonProps) => {
    // Helper array to generate rows without copy-pasting
    const rowArray = Array.from(new Array(rows));
    // Helper array to simulate the approx 7 columns seen in image
    const colArray = Array.from(new Array(columns));

    return (
        <Container>
            <Box sx={{ width: '100%' }}>

                {/* 1. HEADER SECTION: Title + 2 Circular Buttons */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2 // Margin bottom to separate from table
                }}>
                    {/* Title "Séries" */}
                    <Skeleton variant="text" width={160} height={55} sx={{ borderRadius: 2 }} />

                    {/* Action Buttons */}
                    <Box sx={{ display: 'flex', gap: 0.7 }}>
                        <Skeleton variant="circular" width={50} height={50} />
                        <Skeleton variant="circular" width={50} height={50} />
                    </Box>
                </Box>

                {/* 2. TABLE CARD */}
                <TableContainer component={Paper} sx={{ p: 2 }}>
                    <Table size="medium">

                        {/* Table Header (Simulating the Blue Bar) */}
                        <TableHead>
                            <TableRow >
                                <TableCell colSpan={columns} sx={{ padding: '12px 12px 0 0', borderBottom: 'none' }}>
                                    <Skeleton variant="text" height={61} width="100%" sx={{ transform: 'none' }} />
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody sx={{height: '100%'}}>
                            {rowArray.map((_, rowIndex) => (
                                <TableRow key={`row-${rowIndex}`}>
                                    {colArray.map((_, colIndex) => (
                                        <TableCell key={`cell-${rowIndex}-${colIndex}`} sx={{ padding: '12px' }}>
                                            {/* Randomize width slightly for realism, or keep uniform */}
                                            <Skeleton
                                                variant="text"
                                                height={60}
                                                width={'100%'}                                                
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    {/* 3. PAGINATION FOOTER SKELETON (Optional) */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 2 }}>
                        <Skeleton variant="text" width={100} height={30} />
                        <Skeleton variant="text" width={50} height={30} />
                    </Box>
                </TableContainer>
            </Box>
        </Container>
    );
};

export default LoadingSkeleton;